(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-blocks"] && !Shopify.designMode) return;
  try {
    // Opens accordion tabs when linked via anchor IDs (e.g., "Read more" button in Short Description block)
  // Provides smooth scrolling with header offset for better navigation UX

  (() => {
    const scrollToAnchor = (anchor) => {
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      const rect = anchor.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const targetPosition = rect.top + scrollTop - headerHeight;
      
      window.scrollTo({
        top: Math.max(0, targetPosition),
        behavior: 'smooth'
      });
    };

    const openAccordionFromAnchor = () => {
      const hash = window.location.hash.substring(1);
      if (!hash) return;

      const anchor = document.getElementById(hash);
      if (!anchor || !anchor.classList.contains('section-anchor')) return;

      const accordion = anchor.nextElementSibling;
      if (!accordion || accordion.tagName !== 'DETAILS' || accordion.getAttribute('is') !== 'accordion-group') return;

      if (!accordion.open) {
        accordion.open = true;
        // Accordion's built-in scroll will handle smooth scrolling
      } else {
        // If already open, scroll smoothly to anchor
        scrollToAnchor(anchor);
      }
    };

    // Intercept clicks on links targeting section-anchors for smooth scroll
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;

      const hash = link.getAttribute('href').substring(1);
      if (!hash) return;

      const anchor = document.getElementById(hash);
      if (!anchor || !anchor.classList.contains('section-anchor')) return;

      e.preventDefault();
      window.history.pushState(null, '', `#${hash}`);
      openAccordionFromAnchor();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openAccordionFromAnchor);
    } else {
      openAccordionFromAnchor();
    }

    window.addEventListener('hashchange', openAccordionFromAnchor);
  })();
  } catch(e) { console.error(e); }
})();

})();
